import { gradientFor, styleForCategory } from "../lib/visual";
import styles from "./TicketStub.module.css";

type Props = {
  eventName: string;
  eventDatetime: string;
  venueName: string;
  section: string;
  row: string;
  quantity: number;
  eventId: string;
  categoryId?: string;
  size?: "default" | "lg";
  orderId?: string;
};

export default function TicketStub({
  eventName,
  eventDatetime,
  venueName,
  section,
  row,
  quantity,
  eventId,
  categoryId,
  size = "default",
  orderId,
}: Props) {
  const gradient = gradientFor(eventId, categoryId);
  const cat = categoryId ? styleForCategory(categoryId) : null;
  const dt = new Date(eventDatetime);
  const dateStr = dt
    .toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    .toUpperCase();
  const timeStr = dt.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div
      className={`${styles.stub} ${size === "lg" ? styles.stubLg : ""}`}
      style={{ background: gradient }}
    >
      {cat && (
        <span className={styles.glyph} aria-hidden>
          {cat.glyph}
        </span>
      )}
      <div className={styles.tint} />

      <div className={styles.head}>
        <div className={styles.kicker}>
          {cat ? cat.shortLabel : "Live event"}
        </div>
        <h3 className={styles.eventName}>{eventName}</h3>
        <div className={styles.meta}>
          <span>{dateStr}</span>
          <span className={styles.dot}>·</span>
          <span>{timeStr}</span>
        </div>
        <div className={styles.venue}>{venueName}</div>
      </div>

      <div className={styles.perforation}>
        <span className={styles.notchLeft} aria-hidden />
        <span className={styles.dashLine} aria-hidden />
        <span className={styles.notchRight} aria-hidden />
      </div>

      <div className={styles.body}>
        <div className={styles.seatGrid}>
          <div className={styles.seatCell}>
            <span className={styles.seatLabel}>Section</span>
            <span className={styles.seatValue}>{section}</span>
          </div>
          <div className={styles.seatCell}>
            <span className={styles.seatLabel}>Row</span>
            <span className={styles.seatValue}>{row}</span>
          </div>
          <div className={styles.seatCell}>
            <span className={styles.seatLabel}>Qty</span>
            <span className={styles.seatValue}>{quantity}</span>
          </div>
        </div>
        {orderId && (
          <div className={styles.orderRow}>
            <span className={styles.seatLabel}>Order</span>
            <span className={styles.orderId}>{orderId}</span>
          </div>
        )}
        <div className={styles.barcode} aria-hidden />
      </div>
    </div>
  );
}
